import { useEffect, useState } from "react";
import { ProjectTypeClient, ProjectTypeDTO } from "../services/apiClient";
import { API_BASE_URL } from "../config/config";
import axiosInstance from "../services/axiosInstance";

export const getProjectTypes = () => {
  const [projectTypes, setProjectTypes] = useState<ProjectTypeDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const projectTypeClient = new ProjectTypeClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
          const fetchProjectTypeNames = async () => {
              setIsLoading(true);
              try {
                  const result = await projectTypeClient.getProjectTypes(); // Call the distinct table names endpoint
                  if (result && result.success && result.data) {
                    setProjectTypes(result.data);
                  } else {
                      setError('Failed to fetch project types names');
                  }
              } catch (err) {
                  setError('Error fetching project types names');
                  console.error('Error fetching project types names:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchProjectTypeNames();
      }, []);
  
      return { projectTypes, isLoading, error };
};
